import React from "react";
import NavbarContent from "../components/Navbar/navbar";
import ContactContent from "../components/Contact/contact";


export default function Contact(){
       return(
              <>
              <NavbarContent/>
              <ContactContent/>
              </>
       )
}